import React from 'react';
import PropTypes from 'prop-types';
import DrawerAnchor from './DrawerAnchor';
import withIsMobile from '../hoc/withIsMobile';

class DetailDrawerAnchor extends React.Component {
	static propTypes = {
		renderDrawerContent: PropTypes.func,
		children: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
		// Mapped to props
		isMobile: PropTypes.func,
	};

	render() {
		const isMobile = this.props.isMobile();
		return (
			<DrawerAnchor
				closable={isMobile}
				width={isMobile ? '100%' : '700px'}
				placement={isMobile ? 'bottom' : 'left'}
				height={isMobile ? '90%' : '100%'}
				renderDrawerContent={this.renderDrawerContent}>
				{this.props.children}
			</DrawerAnchor>
		);
	}

	renderDrawerContent = drawer => {
		return drawer.isVisible && this.props.renderDrawerContent();
	};
}

export default withIsMobile(DetailDrawerAnchor);
